import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withStyles,
  Grid,
  FormControl,
  InputLabel,
  OutlinedInput,
} from '@material-ui/core'
import { list, create, update, deleteEntity } from 'actions/data'
import Button from 'components/theme/Button'
import { Add, Cancel, Delete } from '@material-ui/icons'
import { omit } from 'lodash'
import NumberFormatCustom from 'components/theme/NumberFormatCustom'
import Tooltip from 'components/theme/HelpTooltip.js'
import CopyToClipboard from 'react-copy-to-clipboard'
import { openSnackbar } from 'actions/view'

const statusMap = { O: 'Open', A: 'Accepted', F: 'Failed', E: 'Expired' }

class Input extends Component {
  componentDidMount() {
    this.forceUpdate()
  }

  render() {
    const { classes, onChange, label, value, inputId, type } = this.props
    return (
      <div style={{ marginBottom: 10 }}>
        <FormControl
          // error={Boolean(error)}
          fullWidth
          variant="outlined"
        >
          <InputLabel
            ref={ref => {
              this.labelRef = ReactDOM.findDOMNode(ref)
            }}
            htmlFor={inputId}
            shrink
            style={{ transform: 'translate(44px, -6px) scale(0.75)' }}
          >
            {label}
          </InputLabel>
          {type === 'phone' ? (
            <OutlinedInput
              id={inputId}
              labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
              value={value}
              onChange={e => onChange(e.target.value)}
              placeholder={`Enter a ${label}`}
              notched
              classes={{
                notchedOutline: classes.notchedOutline,
              }}
              inputComponent={NumberFormatCustom}
            />
          ) : (
            <OutlinedInput
              id={inputId}
              labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
              value={value}
              onChange={e => onChange(e.target.value)}
              placeholder={`Enter a ${label}`}
              notched
              classes={{
                notchedOutline: classes.notchedOutline,
              }}
            />
          )}
          {/* <FormHelperText error={Boolean(error)}>
          {error}
        </FormHelperText> */}
        </FormControl>
      </div>
    )
  }
}

class Invite extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fullname: props.fullname,
      email: props.email,
      mobile_number: props.mobile_number?.slice?.(2),
    }
  }

  handleChange = (key, value) => {
    this.setState({ [key]: value })
  }

  render() {
    const {
      invite,
      fullname,
      email,
      mobile_number,
      update,
      deleteEntity,
      classes,
    } = this.props

    const changed =
      fullname !== this.state.fullname ||
      email !== this.state.email ||
      mobile_number !== this.state.mobile_number

    return (
      <div style={{ borderTop: '1px solid #adadad', padding: 20 }}>
        <div style={{ marginBottom: 10 }}>
          Status: {(invite.status && statusMap[invite.status]) || 'Unknown'}
        </div>
        <div>
          <Input
            inputId={`${invite.id}fullName`}
            label="Full name"
            classes={classes}
            onChange={value => this.handleChange('fullname', value)}
            value={this.state.fullname}
          />
        </div>
        <div>
          <Input
            inputId={`${invite.id}Email`}
            label="Email"
            classes={classes}
            onChange={value => this.handleChange('email', value)}
            value={this.state.email}
          />
        </div>
        <div>
          <Input
            inputId={`${invite.id}Number`}
            label="Phone number"
            classes={classes}
            onChange={value => this.handleChange('mobile_number', value)}
            value={this.state.mobile_number}
            type="phone"
          />
        </div>
        <Button
          style={{ marginBottom: 10 }}
          color="secondary"
          variant="contained"
          disabled={!changed}
          onClick={() =>
            update(
              {
                ...invite,
                fullname: this.state.fullname || undefined,
                email: this.state.email || undefined,
                mobile_number:
                  (this.state.mobile_number &&
                    `+1${this.state.mobile_number}`) ||
                  undefined,
              },
              'account/reservation',
              null,
              'account/reservation/id',
            )
          }
        >
          {changed ? 'Resend' : 'Sent'}
        </Button>
        <CopyToClipboard
          onCopy={() =>
            this.props.openSnackbar({
              type: 'success',
              message: 'The invitation URL has been copied to your clipboard!',
            })
          }
          text={`${
            window?.location?.href?.slice?.(0, 29) ===
            'https://console.vastreach.com'
              ? 'https://console.vastreach.com'
              : 'https://d3onl0poh29icq.cloudfront.net'
          }/userinvitation?templver=4${
            this.props.acctID ? `&acctID=${this.props.acctID}` : ''
          }&email=${encodeURIComponent(this.state.email).replace(/%20/g, '+')}${
            invite.id ? `&id=${invite.id}` : ''
          }${
            this.props.inviter_company
              ? `&inviter_company=${encodeURIComponent(
                  this.props.inviter_company,
                ).replace(/%20/g, '+')}`
              : ''
          }${
            invite.inviter_email
              ? `&inviter_email=${encodeURIComponent(
                  invite.inviter_email,
                ).replace(/%20/g, '+')}`
              : ''
          }${
            invite.inviter_fullname
              ? `&inviter_fullname=${encodeURIComponent(
                  invite.inviter_fullname,
                ).replace(/%20/g, '+')}`
              : ''
          }&mobile=%2B1${this.state.mobile_number}&name=${encodeURIComponent(
            this.state.fullname,
          ).replace(/%20/g, '+')}${
            invite.reqtok_v1 ? `&reqtok_v1=${invite.reqtok_v1}` : ''
          }&utcexp=${encodeURIComponent(invite.expires_at)}`}
        >
          <Button
            style={{ marginBottom: 10, marginLeft: 10 }}
            color="secondary"
            variant="contained"
          >
            Copy invitation URL
          </Button>
        </CopyToClipboard>
        <div>
          <Button
            variant="outlined"
            onClick={() =>
              window.confirm(
                'Are you sure you want to delete this reservation?',
              ) && deleteEntity(invite.id, 'account/reservation')
            }
          >
            <Delete style={{ marginRight: 5 }} />
            Cancel invitation
          </Button>
        </div>
      </div>
    )
  }
}

class Invites extends Component {
  state = {
    fullname: '',
    email: '',
    mobile_number: '',
    createInvitationToggled: false,
  }

  componentDidMount() {
    this.props.list('account/reservation')
  }

  handleChange = (id, key, value) => {
    this.setState({ [id]: { ...this.state[id], [key]: value } })
  }

  inputValue = (invite, key) => {
    if (
      this.state[invite.id] &&
      typeof this.state[invite.id][key] !== 'undefined'
    ) {
      return this.state[invite.id][key]
    }
    if (invite[key]) {
      return invite[key]
    }
    return ''
  }

  render() {
    const { create, invites, classes, update, deleteEntity } = this.props

    const { createInvitationToggled } = this.state

    return (
      <>
        <div className={classes.titleText} style={{ padding: '20px 0 6px 0' }}>
          USER INVITATION{' '}
          <Tooltip>
            <span>
              A user can be someone (such as an employee) the owner invites to
              assist with his/her business using <strong>Vast Reach</strong>.
              You can begin inviting a user by clicking{' '}
              <strong>+ ADD INVITATION</strong> button. There will be three
              input fields that are presented (Users Full name, email and phone
              number) and once filled you can click the <strong>CREATE</strong>{' '}
              button below. Once a user has been invited there will be a{' '}
              <strong>Status:</strong> indication above until the user accepts
              the invitation. Once the user accepts, they will show up on the
              user list under the users tab.
            </span>
          </Tooltip>
        </div>
        <div className={classes.paper}>
          <Grid style={{ padding: 20 }} container justify="space-between">
            <Grid item>
              <div style={{ fontSize: 14 }}>Invite users to Vast Reach!</div>
            </Grid>
            <Grid item>
              <Button
                onClick={() =>
                  this.setState({
                    createInvitationToggled: !createInvitationToggled,
                  })
                }
                size="small"
                variant={createInvitationToggled ? 'outlined' : 'contained'}
                color={createInvitationToggled ? 'default' : 'secondary'}
              >
                {createInvitationToggled ? (
                  <Cancel style={{ marginRight: 5 }} />
                ) : (
                  <Add style={{ marginRight: 5 }} />
                )}
                {createInvitationToggled ? 'Cancel' : 'Add invitation'}
              </Button>
            </Grid>
          </Grid>
          {createInvitationToggled && (
            <div style={{ borderTop: '1px solid #adadad', padding: 20 }}>
              <div>
                <Input
                  inputId="newFullName"
                  label="Full name"
                  classes={classes}
                  value={this.state.fullname}
                  onChange={value => this.setState({ fullname: value })}
                />
              </div>
              <div>
                <Input
                  inputId="newEmail"
                  label="Email"
                  classes={classes}
                  value={this.state.email}
                  onChange={value => this.setState({ email: value })}
                />
              </div>
              <div>
                <Input
                  inputId="newMobileNumber"
                  label="Phone number"
                  classes={classes}
                  value={this.state.mobile_number}
                  onChange={value => this.setState({ mobile_number: value })}
                  type="phone"
                />
              </div>
              <Button
                color="secondary"
                variant="contained"
                onClick={() => {
                  create({
                    entity: Object.keys(
                      omit(this.state, 'createInvitationToggled'),
                    ).reduce((acc, el) => {
                      if (this.state[el]) {
                        if (el === 'mobile_number') {
                          acc[el] = `+1${this.state[el]}`
                        } else {
                          acc[el] = this.state[el]
                        }
                      }
                      return acc
                    }, {}),
                    entityType: 'account/reservation',
                  }).then(() =>
                    this.setState({
                      fullname: '',
                      email: '',
                      mobile_number: '',
                      createInvitationToggled: false,
                    }),
                  )
                }}
              >
                Create
              </Button>
            </div>
          )}
          {invites.map(invite => (
            <Invite
              fullname={invite.fullname || ''}
              mobile_number={invite.mobile_number || ''}
              email={invite.email || ''}
              invite={invite}
              update={update}
              deleteEntity={deleteEntity}
              key={`invite${invite.id}`}
              classes={classes}
              openSnackbar={this.props.openSnackbar}
              acctID={this.props.acctID}
              inviter_company={this.props.inviter_company}
            />
          ))}
        </div>
      </>
    )
  }
}

export default connect(
  state => ({
    invites: state.data['account/reservation']
      ? Object.values(state.data['account/reservation'])
      : [],
    loadStatus: state.loadStatus.invites,
    acctID: state.auth?.session?.idToken?.payload?.['custom:vr_account_id'],
    inviter_company: state.data.account?.business_name,
  }),
  dispatch =>
    bindActionCreators(
      { list, create, update, deleteEntity, openSnackbar },
      dispatch,
    ),
)(
  withStyles(theme => ({
    notchedOutline: {
      borderRadius: 28,
      paddingLeft: '40px !important',
    },
    titleText: {
      marginBottom: 14,
      fontSize: 25,
      fontWeight: 'bold',
      color: '#014c94',
      [theme.breakpoints.down('sm')]: {
        fontSize: 19,
        // marginBottom: 12,
      },
    },
    paper: {
      border: '1px solid #adadad',
      // padding: 20,
      borderRadius: 35,
      // [theme.breakpoints.down('sm')]: {
      //   padding: 0,
      //   height: 'calc(100% - 56px)',
      // },
    },
  }))(Invites),
)
